import { render } from "./ToDoItemPersonItem.vue?vue&type=template&id=60d539d1&scoped=true"
import script from "./ToDoItemPersonItem.vue?vue&type=script&lang=js"
export * from "./ToDoItemPersonItem.vue?vue&type=script&lang=js"

import "./ToDoItemPersonItem.vue?vue&type=style&index=0&id=60d539d1&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60d539d1"]])

export default __exports__